<template>
  <div style="margin-top: -10px !important">
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
    <div v-else>
      <div
        :class="{ sidebarStatic, sidebarClose, recurringview: true }"
        style="margin-top: -10px !important"
      >
        <b-row
          class="hidden-sm-down d-print-none px-pad border-bottom justify-content-center"
          style="height: 42px"
        >
          <!--  Page Title -->
          <b-col
            cols="4"
            md="4"
            xl="4"
            lg="4"
            sm="4"
            xs="4"
            class="text-left px-0"
          >
            <h2 class="custom-page-title mb-2 mt-1">
              {{ list.recurring_invoice_header_detail.rec_inv_no }}
            </h2>
          </b-col>
          <!--  Header Buttons -->
          <b-col
            cols="8"
            md="8"
            xl="8"
            lg="8"
            sm="8"
            xs="8"
            class="text-right px-0"
          >
            <b-button
              v-if="RoutePermission(false, '', 'invoice', 'invoice', 'create')"
              variant="primary"
              size="sm"
              class="mr-2"
              v-b-modal.converttoinvoice
              >Create {{ type }}</b-button
            >
             <b-button variant="primary" 
        size="sm"
        class="mr-2" 
      v-if="RoutePermission(false,'','','recurringinvoice','create')"
        :to="{ name: 'RecurringInvoiceCreate', query:{page_from:'view',old_id:$route.params.id}}">
        New Recurring Invoice
        </b-button>

            <b-button-group variant="light">
              <b-button
                v-if="
                  RoutePermission(
                    false,
                    '',
                    'invoice',
                    'recurringinvoice',
                    'update'
                  )
                "
                size="sm"
                :to="{
                  name: 'RecurringInvoiceUpdate',
                  params: { id: $route.params.id },
                  query: {
                    type:
                      list.recurring_invoice_header_detail.inv_type == 1
                        ? 'invoice'
                        : 'bill_of_supply',
                    page_from: 'view',
                  },
                }"
                variant="light"
              >
                <i class="la la-edit la-lg"></i>
              </b-button>
              <b-dropdown
                right
                text="More"
                variant="light"
                size="sm"
                style="height: 31px !important"
                v-if="
                  RoutePermission(
                    false,
                    '',
                    'invoice',
                    'recurringinvoice',
                    'update'
                  ) ||
                  RoutePermission(
                    false,
                    '',
                    'invoice',
                    'recurringinvoice',
                    'create'
                  ) ||
                  RoutePermission(
                    false,
                    '',
                    'invoice',
                    'recurringinvoice',
                    'delete'
                  )
                "
              >
                <b-dropdown-item
                  v-b-modal.stoprecurringinvoice
                  v-if="
                    list.recurring_invoice_header_detail.rec_inv_status != 2 &&
                    RoutePermission(
                      false,
                      '',
                      'invoice',
                      'recurringinvoice',
                      'update'
                    )
                  "
                >
                  <i
                    :class="
                      list.recurring_invoice_header_detail.rec_inv_status == 1
                        ? 'la-ban'
                        : 'la-refresh'
                    "
                    class="la la-lg mr-3"
                  ></i>
                  <span>{{
                    (list.recurring_invoice_header_detail.rec_inv_status == 1
                      ? "Stop"
                      : "Resume") + " Recurring"
                  }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    RoutePermission(
                      false,
                      '',
                      'invoice',
                      'recurringinvoice',
                      'create'
                    )
                  "
                  :to="{
                    name: 'RecurringInvoiceCreate',
                    query: {
                      clone_id: $route.params.id,
                      type: type,
                      page_from: 'view',
                    },
                  }"
                >
                  <i class="la la-clone la-lg mr-3"></i>Clone
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    RoutePermission(
                      false,
                      '',
                      'invoice',
                      'recurringinvoice',
                      'delete'
                    )
                  "
                  @click="
                    handlingapprovingmodal({
                      content:
                        'Are you sure you want to delete this Recurring' +
                        type +
                        '?',
                      title:
                        'Delete ' +
                        type +
                        '- ' +
                        list.recurring_invoice_header_detail.rec_inv_no,
                      module: 'recurringinvoice/deleterecurringinvoice',
                      data: JSON.stringify({
                        id: $route.params.id,
                      }),
                      RoutePlace: 'RecurringInvoice',
                      isRoute: 'true',
                      type: 'delete',
                      route_history: recurringinvoice_index_history,
                    })
                  "
                >
                  <i class="la la-trash la-lg mr-3"></i>Delete
                </b-dropdown-item>
              </b-dropdown>
              <b-button
                variant="light"
                size="sm"
                title="close"
                :to="
                  recurringinvoice_index_history
                    ? recurringinvoice_index_history
                    : { name: 'RecurringInvoice' }
                "
              >
                <i class="la la-remove la-lg text-decoration-none"></i>
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <!--  Tabs and its contents -->
        <div class="d-flex" style="margin-left: -20px; margin-right: -20px">
          <div class="view-content-block border-left d-none d-lg-block">
            <div class="py-3">
              <h6
                class="fw-semi-bold theme-text-color px-pad"
                style="padding-bottom: 6px"
              >
                Customer Details
              </h6>
              <div class="border-bottom"></div>
              <b-row class="px-pad pt-2 pb-1">
                <b-col cols="4">Name</b-col>
                <b-col cols="8" class="text-truncate">{{
                  list.recurring_invoice_header_detail.cus_name
                }}</b-col>
              </b-row>
              <b-row class="px-pad pt-2 pb-1">
                <b-col cols="4">Phone</b-col>
                <b-col cols="8">{{
                  list.recurring_invoice_header_detail.cus_ph_no
                }}</b-col>
              </b-row>
              <div class="border-bottom"></div>
              <b-tabs class="customer_view_tab custom-tab" card>
                <b-tab
                  title="Details"
                  active
                  class="px-pad py-2"
                  title-link-class="text-center"
                >
                  <div class="w-100">
                    <div class="d-flex w-100 py-2">
                      <div class="cus-view-addr w-50 text-muted">
                        Profile Status
                      </div>
                      <div class="cus-view-addr w-50">
                        {{
                          list.recurring_invoice_header_detail
                            .rec_inv_status_name
                        }}
                      </div>
                    </div>

                    <div class="d-flex w-100 py-2">
                      <div class="cus-view-addr w-50 text-muted">
                        Start date
                      </div>
                      <div class="cus-view-addr w-50">
                        {{
                          getDateFormat(
                            list.recurring_invoice_header_detail.rec_start_date
                          )
                        }}
                      </div>
                    </div>
                    <div class="d-flex w-100 py-2">
                      <div class="cus-view-addr w-50 text-muted">End date</div>
                      <div class="cus-view-addr w-50">
                        {{
                          list.recurring_invoice_header_detail.rec_end_date ==
                          null
                            ? "Never Expires"
                            : getDateFormat(
                                list.recurring_invoice_header_detail
                                  .rec_end_date
                              )
                        }}
                      </div>
                    </div>
                    <div class="d-flex w-100 py-2">
                      <div class="cus-view-addr w-50 text-muted">
                        Payment Terms
                      </div>
                      <div class="cus-view-addr w-50">
                        {{ list.recurring_invoice_header_detail.term_name }}
                      </div>
                    </div>

                    <div
                      class="d-flex w-100 py-2"
                      v-for="custom_field in rec_inv_settings_details.custom_field"
                      v-if="
                        custom_field.print_show == 1 &&
                        custom_field.status == 1 &&
                        custom_field.permissions != 'hide'
                      "
                      :key="custom_field.index"
                    >
                      <div class="cus-view-addr w-50 text-muted">
                        {{ custom_field.label_name }}
                      </div>
                      <div class="cus-view-addr w-50">
                        {{
                          list.recurring_invoice_header_detail[
                            custom_field.field_name
                          ]
                        }}
                      </div>
                    </div>
                    <div
                      class="d-flex w-100 py-2"
                      v-if="list.recurring_invoice_header_detail.inv_notes"
                      style="word-break: break-word !important"
                    >
                      <div class="cus-view-addr w-50 text-muted">
                        Customer Notes
                      </div>
                      <div class="cus-view-addr w-50">
                        {{ list.recurring_invoice_header_detail.inv_notes }}
                      </div>
                    </div>
                    <div
                      class="d-flex w-100 py-2"
                      v-if="
                        list.recurring_invoice_header_detail.manual_inv_count
                      "
                      style="word-break: break-word !important"
                    >
                      <div class="w-50 text-muted">
                        Manually Created {{ type }}(s)
                      </div>
                      <div class="cus-view-addr w-50">
                        {{
                          list.recurring_invoice_header_detail.manual_inv_count
                        }}
                      </div>
                    </div>
                    <div
                      class="d-flex w-100 py-2"
                      v-if="
                        list.recurring_invoice_header_detail
                          .remaining_recurring_cycle
                      "
                      style="word-break: break-word !important"
                    >
                      <div class="w-50 text-muted">Remaining billing cycle</div>
                      <div class="cus-view-addr w-50">
                        {{
                          list.recurring_invoice_header_detail
                            .remaining_recurring_cycle
                        }}
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab
                  title="Address"
                  class="px-pad py-2"
                  title-link-class="text-center"
                >
                  <div class="w-100">
                    <div class="py-2">
                      <span class="theme-text-color pb-2">Billing Address</span>
                      <template
                        v-if="
                          typeof list
                            .recurring_invoice_header_address_detail[1] !==
                          'undefined'
                        "
                      >
                        <div class="py-2">
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_address_detail[1]
                              .cus_addr_line_1
                          }}</span>
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_address_detail[1]
                              .cus_addr_line_2
                          }}</span>
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_address_detail[1]
                              .cus_city
                          }}</span>
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_address_detail[1]
                              .cus_pincode
                          }}</span>
                          <span class="cus-view-addr">{{
                            getDetails(
                              $AppDetails.state_details,
                              list.recurring_invoice_header_address_detail[1]
                                .cus_state,
                              "state_name"
                            )
                          }}</span>
                          <span class="cus-view-addr">{{
                            getDetails(
                              $AppDetails.country_details,
                              list.recurring_invoice_header_address_detail[1]
                                .cus_country,
                              "country_name"
                            )
                          }}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="w-100">
                    <div class="py-2">
                      <span class="theme-text-color pb-2"
                        >Shipping Address</span
                      >
                      <template
                        v-if="
                          typeof list
                            .recurring_invoice_header_address_detail[2] !==
                          'undefined'
                        "
                      >
                        <div class="py-2">
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_detail.cus_name
                          }}</span>
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_address_detail[2]
                              .cus_addr_line_1
                          }}</span>
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_address_detail[2]
                              .cus_addr_line_2
                          }}</span>
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_address_detail[2]
                              .cus_city
                          }}</span>
                          <span class="cus-view-addr">{{
                            list.recurring_invoice_header_address_detail[2]
                              .cus_pincode
                          }}</span>
                          <span class="cus-view-addr">{{
                            getDetails(
                              $AppDetails.state_details,
                              list.recurring_invoice_header_address_detail[2]
                                .cus_state,
                              "state_name"
                            )
                          }}</span>
                          <span class="cus-view-addr">{{
                            getDetails(
                              $AppDetails.country_details,
                              list.recurring_invoice_header_address_detail[2]
                                .cus_country,
                              "country_name"
                            )
                          }}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
              <div class="border-bottom"></div>
            </div>
          </div>
          <div class="view-tab-block">
            <b-tabs
              class="customer_view_tab no-flex-grow mt-2 border-tab"
              v-model="tab_index"
            >
              <b-tab
                title="Overview"
                title-link-class="check  d-block d-lg-none"
                class="p-0"
              >
                <div class="py-3">
                  <h6
                    class="fw-semi-bold theme-text-color px-pad"
                    style="padding-bottom: 6px"
                  >
                    Customer Details
                  </h6>
                  <div class="border-bottom"></div>
                  <b-row class="px-pad pt-2 pb-1">
                    <b-col cols="4">Name</b-col>
                    <b-col cols="8" class="text-truncate">{{
                      list.recurring_invoice_header_detail.cus_name
                    }}</b-col>
                  </b-row>
                  <b-row class="px-pad pt-2 pb-1">
                    <b-col cols="4">Phone</b-col>
                    <b-col cols="8">{{
                      list.recurring_invoice_header_detail.cus_ph_no
                    }}</b-col>
                  </b-row>
                  <div class="border-bottom"></div>
                  <b-tabs class="customer_view_tab custom-tab" card>
                    <b-tab
                      title="Details"
                      active
                      class="px-pad py-2"
                      title-link-class="text-center"
                    >
                      <div class="w-100">
                        <div class="d-flex w-100 py-2">
                          <div class="cus-view-addr w-50 text-muted">
                            Profile Status
                          </div>
                          <div class="cus-view-addr w-50">
                            {{
                              list.recurring_invoice_header_detail
                                .rec_inv_status_name
                            }}
                          </div>
                        </div>

                        <div class="d-flex w-100 py-2">
                          <div class="cus-view-addr w-50 text-muted">
                            Start date
                          </div>
                          <div class="cus-view-addr w-50">
                            {{
                              getDateFormat(
                                list.recurring_invoice_header_detail
                                  .rec_start_date
                              )
                            }}
                          </div>
                        </div>
                        <div class="d-flex w-100 py-2">
                          <div class="cus-view-addr w-50 text-muted">
                            End date
                          </div>
                          <div class="cus-view-addr w-50">
                            {{
                              list.recurring_invoice_header_detail
                                .rec_end_date == null
                                ? "Never Expires"
                                : getDateFormat(
                                    list.recurring_invoice_header_detail
                                      .rec_end_date
                                  )
                            }}
                          </div>
                        </div>
                        <div class="d-flex w-100 py-2">
                          <div class="cus-view-addr w-50 text-muted">
                            Payment Terms
                          </div>
                          <div class="cus-view-addr w-50">
                            {{ list.recurring_invoice_header_detail.term_name }}
                          </div>
                        </div>

                        <div
                          class="d-flex w-100 py-2"
                          v-for="custom_field in rec_inv_settings_details.custom_field"
                          v-if="
                            custom_field.print_show == 1 &&
                            custom_field.status == 1 &&
                            custom_field.created == 1
                          "
                          :key="custom_field.index"
                        >
                          <div class="cus-view-addr w-50 text-muted">
                            {{ custom_field.label_name }}
                          </div>
                          <div class="cus-view-addr w-50">
                            {{
                              list.recurring_invoice_header_detail[
                                custom_field.field_name
                              ]
                            }}
                          </div>
                        </div>
                        <div
                          class="d-flex w-100 py-2"
                          v-if="list.recurring_invoice_header_detail.inv_notes"
                          style="word-break: break-word !important"
                        >
                          <div class="cus-view-addr w-50 text-muted">
                            Customer Notes
                          </div>
                          <div class="cus-view-addr w-50">
                            {{ list.recurring_invoice_header_detail.inv_notes }}
                          </div>
                        </div>
                        <div
                          class="d-flex w-100 py-2"
                          v-if="
                            list.recurring_invoice_header_detail
                              .manual_inv_count
                          "
                          style="word-break: break-word !important"
                        >
                          <div class="w-50 text-muted">
                            Manually Created {{ type }}(s)
                          </div>
                          <div class="cus-view-addr w-50">
                            {{
                              list.recurring_invoice_header_detail
                                .manual_inv_count
                            }}
                          </div>
                        </div>
                        <div
                          class="d-flex w-100 py-2"
                          v-if="
                            list.recurring_invoice_header_detail
                              .remaining_recurring_cycle
                          "
                          style="word-break: break-word !important"
                        >
                          <div class="w-50 text-muted">
                            Remaining billing cycle
                          </div>
                          <div class="cus-view-addr w-50">
                            {{
                              list.recurring_invoice_header_detail
                                .remaining_recurring_cycle
                            }}
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab
                      title="Address"
                      class="px-pad py-2"
                      title-link-class="text-center"
                    >
                      <div class="w-100">
                        <div class="py-2">
                          <span class="theme-text-color pb-2"
                            >Billing Address</span
                          >
                          <template
                            v-if="
                              typeof list
                                .recurring_invoice_header_address_detail[1] !==
                              'undefined'
                            "
                          >
                            <div class="py-2">
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_address_detail[1]
                                  .cus_addr_line_1
                              }}</span>
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_address_detail[1]
                                  .cus_addr_line_2
                              }}</span>
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_address_detail[1]
                                  .cus_city
                              }}</span>
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_address_detail[1]
                                  .cus_pincode
                              }}</span>
                              <span class="cus-view-addr">{{
                                getDetails(
                                  $AppDetails.state_details,
                                  list
                                    .recurring_invoice_header_address_detail[1]
                                    .cus_state,
                                  "state_name"
                                )
                              }}</span>
                              <span class="cus-view-addr">{{
                                getDetails(
                                  $AppDetails.country_details,
                                  list
                                    .recurring_invoice_header_address_detail[1]
                                    .cus_country,
                                  "country_name"
                                )
                              }}</span>
                            </div>
                          </template>
                        </div>
                      </div>
                      <div class="w-100">
                        <div class="py-2">
                          <span class="theme-text-color pb-2"
                            >Shipping Address</span
                          >
                          <template
                            v-if="
                              typeof list
                                .recurring_invoice_header_address_detail[2] !==
                              'undefined'
                            "
                          >
                            <div class="py-2">
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_detail.cus_name
                              }}</span>
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_address_detail[2]
                                  .cus_addr_line_1
                              }}</span>
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_address_detail[2]
                                  .cus_addr_line_2
                              }}</span>
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_address_detail[2]
                                  .cus_city
                              }}</span>
                              <span class="cus-view-addr">{{
                                list.recurring_invoice_header_address_detail[2]
                                  .cus_pincode
                              }}</span>
                              <span class="cus-view-addr">{{
                                getDetails(
                                  $AppDetails.state_details,
                                  list
                                    .recurring_invoice_header_address_detail[2]
                                    .cus_state,
                                  "state_name"
                                )
                              }}</span>
                              <span class="cus-view-addr">{{
                                getDetails(
                                  $AppDetails.country_details,
                                  list
                                    .recurring_invoice_header_address_detail[2]
                                    .cus_country,
                                  "country_name"
                                )
                              }}</span>
                            </div>
                          </template>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                  <div class="border-bottom"></div>
                </div>
              </b-tab>
              <b-tab :title="'Recurring ' + type" class="p-0">
                <div class="view-block d-flex">
                  <b-row class="w-100">
                    <b-col
                      cols="12"
                      lg="12"
                      md="12"
                      xl="12"
                      sm="12"
                      class="py-3 d-flex"
                    >
                      <div class="text-center m-auto px-pad">
                        <h6 class="mb-1 h6-lg">{{ type }} Amount</h6>
                        <div
                          class="mx-auto"
                          style="
                            width: 50px;
                            border-top: 2px solid rgb(252, 117, 104);
                            position: relative;
                          "
                        ></div>
                        <div class="mx-auto mt-3">
                          <div class="w-100">
                            <h6 class="text-muted text-truncate h6-lg">
                              {{
                                currency_symbol +
                                " " +
                                parseFloat(
                                  list.recurring_invoice_header_detail
                                    .grand_total
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              }}
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center m-auto px-pad"
                        v-if="
                          list.recurring_invoice_header_detail.next_inv_date !=
                            null &&
                          list.recurring_invoice_header_detail.next_inv_date !=
                            ''
                        "
                      >
                        <h6 class="mb-1 h6-lg">
                          {{
                            list.recurring_invoice_header_detail.inv_type != "2"
                              ? "Next Invoice"
                              : "Next Bill of Supply"
                          }}
                        </h6>
                        <div
                          class="mx-auto"
                          style="
                            width: 50px;
                            border-top: 2px solid rgb(252, 117, 104);
                            position: relative;
                          "
                        ></div>
                        <div class="mx-auto mt-3">
                          <div class="w-100">
                            <h6
                              class="text-muted text-truncate cursor_pointer h6-lg"
                            >
                              <span @click="tab_index = 2">{{
                                getDateFormat(
                                  list.recurring_invoice_header_detail
                                    .next_inv_date
                                )
                              }}</span>
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div class="text-center m-auto px-pad" v-else>
                        <h6 class="mb-1 h6-lg">Expired</h6>
                        <div
                          class="mx-auto"
                          style="
                            width: 50px;
                            border-top: 2px solid rgb(252, 117, 104);
                            position: relative;
                          "
                        ></div>
                        <div class="mx-auto mt-3">
                          <div class="w-100">
                            <h6 class="text-muted text-truncate h6-lg">
                              {{
                                getDateFormat(
                                  list.recurring_invoice_header_detail
                                    .rec_end_date
                                )
                              }}
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div class="text-center m-auto px-pad">
                        <h6 class="mb-1 h6-lg">Recurring Period</h6>
                        <div
                          class="mx-auto"
                          style="
                            width: 50px;
                            border-top: 2px solid rgb(252, 117, 104);
                            position: relative;
                          "
                        ></div>
                        <div class="mx-auto mt-3">
                          <div class="w-100">
                            <h6 class="text-muted text-truncate h6-lg">
                              {{
                                list.recurring_invoice_header_detail.frequency
                              }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div role="tablist">
                  <template v-if="list.rec_inv_history.length == 0">
                    <div
                      class="container pt-2 mt-5 text-center"
                      style="align: center"
                      v-if="
                        list.recurring_invoice_header_detail.next_inv_date !=
                          '' &&
                        list.recurring_invoice_header_detail.next_inv_date !=
                          null
                      "
                    >
                      <h5 class="text-muted">
                        Recurring {{ type }}s for this profile will begin from
                        {{
                          getDateFormat(
                            list.recurring_invoice_header_detail.next_inv_date
                          )
                        }}
                      </h5>
                    </div>
                    <div
                      v-else
                      class="container pt-2 mt-5 text-center"
                      style="align: center"
                    >
                      <img
                        src="@/assets/vector/no-msg.png"
                        style="width: 350px"
                      />
                      <br />
                      <span
                        >No {{ type }} generated for this recurring
                        {{ type }}</span
                      >
                    </div>
                  </template>
                  <template v-else>
                    <table class="px-0 table table-hover" align="center">
                      <tbody>
                        <tr v-for="item in list.rec_inv_history" :key="item.id">
                          <td
                            style="
                              padding-left: 22px !important;
                              padding-right: 22px !important;
                            "
                          >
                            <b-row>
                              <b-col style="text-align: left">
                                <p class="name">
                                  <strong>{{ item.cus_name }}</strong>
                                </p>
                                <p class="text-link">
                                  <router-link
                                    v-if="
                                      RoutePermission(
                                        false,
                                        '',
                                        'invoice',
                                        'invoice',
                                        'index'
                                      )
                                    "
                                    :to="{
                                      name: 'InvoiceView',
                                      params: { id: item.inv_hdr_id },
                                      query: {
                                        page_from: 'recurring',
                                        id: $route.params.id,
                                        view_no:
                                          list.recurring_invoice_header_detail
                                            .rec_inv_no,
                                      },
                                    }"
                                  >
                                    {{ item.inv_no }}
                                    <span style="color: black">{{
                                      getDateFormat(item.created_date)
                                    }}</span>
                                  </router-link>
                                  <template v-else>
                                    {{ item.inv_no }}
                                    <span style="color: black">{{
                                      getDateFormat(item.created_date)
                                    }}</span>
                                  </template>
                                </p>
                                <p
                                  class="my-auto"
                                  v-if="item.is_manual_inv == 1"
                                >
                                  <small class="text-muted">
                                    <i class="fa fa-info-circle fa-xs mr-2"></i
                                    >Manually Added
                                  </small>
                                </p>
                              </b-col>
                              <b-col style="text-align: right">
                                <p>
                                  {{
                                    currency_symbol +
                                    " " +
                                    parseFloat(item.grand_total).toLocaleString(
                                      undefined,
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )
                                  }}
                                </p>

                                <p>{{ item.inv_status_name }}</p>
                                <router-link
                                  :to="{
                                    name: 'InvoicePayment',
                                    params: { id: item.inv_hdr_id },
                                    query: {
                                      page: 'recurring',
                                      rec_id: $route.params.id,
                                    },
                                  }"
                                  v-if="
                                    item.inv_status != 1 &&
                                    item.inv_status != 4 &&
                                    item.inv_status != 7 &&
                                    item.inv_status != 6 &&
                                    RoutePermission(
                                      false,
                                      '',
                                      'invoice',
                                      'paymentsreceived',
                                      'create'
                                    )
                                  "
                                >
                                  <b-button
                                    variant="success"
                                    size="sm"
                                    class="mb-xs"
                                    >Record Payment</b-button
                                  >
                                </router-link>
                              </b-col>
                            </b-row>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </div>
              </b-tab>
              <b-tab
                :title="'Next ' + type"
                title-link-class="check"
                class="p-0"
                v-if="
                  list.recurring_invoice_header_detail.rec_inv_status != 2 &&
                  (list.recurring_invoice_header_detail.next_inv_date !=
                    'null' ||
                    list.recurring_invoice_header_detail.next_inv_date != '')
                "
              >
                <StandardPrint
                  class="p-4 custom-md-width"
                  :list="list"
                  v-if="inv_settings_details.print.templateId == 1"
                ></StandardPrint>
                <SpreadsheetPrint
                  class="p-4 custom-md-width"
                  :list="list"
                  v-if="inv_settings_details.print.templateId == 2"
                ></SpreadsheetPrint>
                <RetailPrint
                  class="p-4 custom-md-width"
                  :list="list"
                  v-if="inv_settings_details.print.templateId == 3"
                ></RetailPrint>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <b-modal
          id="converttoinvoice"
          size="sm"
          ref="modal"
          body-class="bg-white"
          cancel-title="Close"
          cancel-variant="light"
          :ok-title-html="convertsubmit == true ? loaderIcon + 'Yes' : 'Yes'"
          :title="'Create ' + type"
          @ok="converttoinvoice"
          :ok-disabled="convertsubmit"
        >
          <p>
            Are you sure about creating an {{ type }} for this recurring
            {{ type }}?
          </p>
        </b-modal>
        <!--  End of tabs and its contents -->
        <!--  recurring invoice delete modal -->
        <GlobalModal
          :content="content"
          :module="module"
          :title="title"
          :data="globalmodaldata"
          :isRoute="isRoute"
          :RoutePlace="RoutePlace"
          :type="globalmodaltype"
          :route_history="route_history"
        />
        <b-modal
          id="stoprecurringinvoice"
          size="md"
          ref="stoprecurringinvoice"
          body-class="bg-white"
          cancel-title="Cancel"
          cancel-variant="light"
          :ok-title-html="
            (submitted == true ? loaderIcon : '') +
            (list.recurring_invoice_header_detail.rec_inv_status == 1
              ? 'Stop it'
              : 'Resume it')
          "
          :title="
            (list.recurring_invoice_header_detail.rec_inv_status == 1
              ? 'Stop'
              : 'Resume') +
            ' Recurring ' +
            type +
            '- ' +
            list.recurring_invoice_header_detail.rec_inv_no
          "
          @ok="stoprecurringinvoice"
          :ok-disabled="submitted"
        >
          <p>
            Are you sure you want to
            {{
              list.recurring_invoice_header_detail.rec_inv_status == 1
                ? "stop"
                : "resume"
            }}
            this recurring {{ type }}?
          </p>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
//import all functions
import { mapState, mapGetters } from "vuex";
import getPageTitle from "@/utils/get-page-title"; // to set page title
import Widget from "@/components/Widget/Widget";
import { number_to_words } from "@/mixins/NumberToWords";
import moment from "moment"; // to control date format
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import store from "@/store/index"; // vuex store fucntion
import StandardPrint from "@/components/Form/RecurringInvoice/Print/Standard";
import SpreadsheetPrint from "@/components/Form/RecurringInvoice/Print/Spreadsheet";
import RetailPrint from "@/components/Form/RecurringInvoice/Print/Retail";
export default {
  mixins: [formatDate],
  props: ["id"],
  data() {
    return {
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      type: "",
      title: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      convertsubmit: false,
      submit: false,
      splitted_tax: [],
      currency_symbol: "",
      inv_due_date: "",
      route_history: "",
      tab_index: this.$route.query.next_inv ? 2 : 1,
      imageSrc: `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5v
                    cmcvMjAwMC9zdmciIHdpZHRoPSIxOTEiIGhlaWdodD0iMTQxIj48cmVjdCB3aWR0aD0
                    iMTkxIiBoZWlnaHQ9IjE0MSIgZmlsbD0iI2VlZSIvPjx0ZXh0IHRleHQtYW5jaG9yPS
                    JtaWRkbGUiIHg9Ijk1LjUiIHk9IjcwLjUiIHN0eWxlPSJmaWxsOiNhYWE7Zm9udC13Z
                    WlnaHQ6Ym9sZDtmb250LXNpemU6MTJweDtmb250LWZhbWlseTpBcmlhbCxIZWx2ZXRp
                    Y2Esc2Fucy1zZXJpZjtkb21pbmFudC1iYXNlbGluZTpjZW50cmFsIj4xOTF4MTQxPC9
                    0ZXh0Pjwvc3ZnPg==`,
    };
  },
  components: {
    Widget,
    StandardPrint,
    SpreadsheetPrint,
    RetailPrint,
  },
  methods: {
    converttoinvoice() {
      this.$router.push({
        name: "InvoiceCreate",
        query: {
          type:
            this.list.recurring_invoice_header_detail.inv_type == 1
              ? "invoice"
              : "bill_of_supply",
          recurring_inv_id: this.id,
        },
      });
    },
    getIndexValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][0][prop] == val) {
          hasMatch = i;

          break;
        }
      }
      return hasMatch;
    },

    //  make expired recurring invoice
    stoprecurringinvoice() {
      this.submitted = true;
      var status =
        this.list.recurring_invoice_header_detail.rec_inv_status == 1 ? 3 : 1;
      this.$store
        .dispatch(
          "recurringinvoice/stoprecurringinvoice",
          JSON.stringify({
            id: this.$route.params.id,
            rec_inv_status: status,
          })
        )
        .then(() => {
          //  code for notificatin display
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          this.submitted = false;
          this.$refs.stoprecurringinvoice.hide();
        });
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
  },
  mounted() {
    var splitted_tax_percent = [];
    this.splitted_tax = [];
    this.list.recurring_invoice_item_detail.reduce((total, value) => {
      var tax_id =
        !isNaN(value.inv_tax_id) && value.inv_tax_id != ""
          ? parseFloat(value.inv_tax_id)
          : 0;
      // <!-----------------------------------dynamic tax calculation based on tax group------------------------------------------>
      if (!isNaN(tax_id) && tax_id != 0) {
        var tax_ids = value.tax_ids ? value.tax_ids.split(",") : "";

        if (tax_ids != "" && tax_ids != null && typeof tax_ids != "undefined") {
          for (var i = 0; i < tax_ids.length; i++) {
            if (
              this.list.tax_list[value.rec_inv_itm_id][i].tax_amount != null &&
              typeof this.list.tax_list[value.rec_inv_itm_id][i].tax_amount !=
                "undefined" &&
              !isNaN(this.list.tax_list[value.rec_inv_itm_id][i].tax_amount)
            ) {
              splitted_tax_percent[tax_ids[i]] = !isNaN(
                splitted_tax_percent[tax_ids[i]]
              )
                ? parseFloat(splitted_tax_percent[tax_ids[i]]) +
                  parseFloat(
                    this.list.tax_list[value.rec_inv_itm_id][i].tax_amount
                  )
                : parseFloat(
                    this.list.tax_list[value.rec_inv_itm_id][i].tax_amount
                  );
            }
            //  update splitted tax variable
            var hasMatch = this.getIndexValue(
              this.splitted_tax,
              "id",
              tax_ids[i],
              ""
            );
            var tax_details = [
              {
                id: tax_ids[i],
                label:
                  this.list.tax_main[tax_ids[i]].tax_name +
                  "[ " +
                  parseFloat(
                    this.list.tax_list[value.rec_inv_itm_id][i].value
                  ) +
                  " %]",
                value: splitted_tax_percent[tax_ids[i]],
              },
            ];
            if (!isNaN(parseInt(hasMatch))) {
              this.splitted_tax[hasMatch] = tax_details;
            } else {
              this.splitted_tax.push(tax_details);
            }
          }
        }
      }
      return;
    }, 0);
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "sales/fetchSalesDetails",
        JSON.stringify({
          type: "recurring_invoice",
        })
      )
      .then(() => {
          store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Recurring Invoice",
        stg_name: "rec_inv_settings_details"
      })
        next();
      });
  },
  created() {
    this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.recurring_invoice_header_detail.cus_currency,
      "currency_symbol"
    );
    this.type =
      this.list.recurring_invoice_header_detail.inv_type == 2
        ? "Bill of supply"
        : "Invoice";
    this.imageSrc =
      this.org_details.org_logo != null
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
    //  fro top page
    document.title = getPageTitle(
      this.list.recurring_invoice_header_detail.rec_inv_no +
        " | " +
        this.$route.meta.title
    );
    //  total in words
    this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.recurring_invoice_header_detail.cus_currency,
        "currency_code_number"
      ) +
      "" +
      number_to_words(
        this.list.recurring_invoice_header_detail.grand_total,
        this.getDetails(
          this.$AppDetails.currency_details,
          this.list.recurring_invoice_header_detail.cus_currency,
          "currency_code_fraction"
        )
      );
    if (this.list.recurring_invoice_header_detail.rec_inv_status != 2) {
      //  update due date based on payment term details

      if (this.list.recurring_invoice_header_detail.cus_pymnt_term == 5) {
        this.inv_due_date = this.formatDate(
          moment(this.list.recurring_invoice_header_detail.next_inv_date).endOf(
            "month"
          )
        );
      } else if (
        this.list.recurring_invoice_header_detail.cus_pymnt_term == 6
      ) {
        var date = moment(
          this.list.recurring_invoice_header_detail.next_inv_date
        ).add(1, "months");
        this.inv_due_date = this.formatDate(moment(date).endOf("month"));
      } else {
        this.inv_due_date = this.formatDate(
          moment(this.list.recurring_invoice_header_detail.next_inv_date).add(
            "days",
            parseInt(this.list.recurring_invoice_header_detail.days)
          )
        );
      }
    }
  },
  computed: {
    ...mapState({
      list: (state) => state.recurringinvoice.list,
      message_type: (state) => state.recurringinvoice.type,
      message: (state) => state.recurringinvoice.message,
      tax_list: (state) => state.sales.tax_list,
      sidebarClose: (state) => state.layout.sidebarClose,
      sidebarStatic: (state) => state.layout.sidebarStatic,
      status_code: (state) => state.recurringinvoice.status_code,
      status_message: (state) => state.recurringinvoice.status_message,
      status_type: (state) => state.recurringinvoice.status_type,
      recurringinvoice_index_history: (state) =>
        state.recurringinvoice.recurringinvoice_index_history,
    }),
    ...mapGetters([
      "org_details",
      "rec_inv_settings_details",
      "inv_settings_details",
    ]),
  },
};
</script>
<style src="./RecurringInvoice.scss" lang="scss"   />





